import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {  notification } from "antd";
import { apiServices } from "../../services/Api.js";


//get holdings data
export const getHoldingsData = createAsyncThunk(
    "holdings/getHoldingsData",
    async (id) => {
        try {
            const response = await apiServices.post(`/customer/${id}/holdings`);
            return response;
        } catch (error) {
            console.error("Error fetching holdings data:", error);
            throw error;
        }
    }
);




const initialState = {
    data: [],
    loading: false,
    error: ""
};

const HoldingsSlice = createSlice({
    name: "holdings",
    initialState,

    extraReducers: (builder) => {
        builder
            .addCase(getHoldingsData.pending, (state) => {
                state.loading = true;
            })
            .addCase(getHoldingsData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = [action.payload];
            })
            .addCase(getHoldingsData.rejected, (state) => {
                state.loading = false;
                state.error = "Error while fetching holdings details";

                if (state.error) {
                    notification.error({
                        message: state.error
                    });
                }
            });
    },
});

const HoldingsReducer = HoldingsSlice.reducer;

export default HoldingsReducer;
